import { Section } from "Components/Section";
import React, { useContext } from "react";
import { DashboardLink } from "Views/DashboardLink";
import { UserContext } from "Views/UserProvider";
import { LcpAppPageWrapper } from "./LcpWorkflowPageWrapper";

export function LossPayeeAddedPage() {
  const { user } = useContext(UserContext);
  return (
    <LcpAppPageWrapper isWide documentTitle={"Loss Payee Added"}>
      <Section title={"Loss Payee Added"}>
        Your loss payee has been successfully added and an email has been sent
        to you with the loss payee documents attached.
        {user && <DashboardLink />}
      </Section>
    </LcpAppPageWrapper>
  );
}
